import { NotFoundQueryQuery, NotFoundQueryQueryVariables } from 'app/graphql/__generated__/types/contento';
import {
    createListTrackingOnClick,
    createTrackingOnItemImpression,
} from 'app/utils/statistics/clientStatistics';
import React from 'react';
import { useQuery } from 'urql';
import env from 'app/env';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { PlayLink } from '../../ui-components/PlayLink.styles';
import PlayText, { SIZE } from '../../ui-components/typography/PlayText/PlayText';
import { generateListTracking } from '../../utils/contentoUtils';
import { isBrowser } from '../../utils/environment';
import ExternalLink from '../ExternalLink/ExternalLink';
import { Loading } from '../Recommendations/Recommendations';
import {
    Container,
    Content,
    Heading,
    List,
    ListHeading,
    RecommendationsCarousel,
    RecommendedShowcase,
} from './NotFound.styles';
import NOT_FOUND_QUERY from './NotFoundQuery.graphql';

const NotFoundRecommendations = () => {
    const [result] = useQuery<NotFoundQueryQuery, NotFoundQueryQueryVariables>({
        query: NOT_FOUND_QUERY,
        variables: {
            includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
        },
        pause: !isBrowser(),
    });

    const { data, fetching } = result;

    if (fetching) {
        <Loading header="Rekommenderat på SVT Play" />;
    }

    if (!data) {
        return null;
    }

    const selection = data.startForSvtPlay?.selections[0];

    if (!selection) {
        return null;
    }

    const listTracking = generateListTracking(selection);

    const onItemClick = createListTrackingOnClick(listTracking);
    const onItemImpression = createTrackingOnItemImpression(listTracking);

    const header = 'Rekommenderat på SVT Play';
    const items = selection.items.slice(0, 6);

    return (
        <>
            <RecommendationsCarousel
                header={header}
                items={items}
                onItemClick={onItemClick}
                onItemImpression={onItemImpression}
            />
            <RecommendedShowcase
                header={header}
                items={items}
                onItemClick={onItemClick}
                onItemImpression={onItemImpression}
            />
        </>
    );
};

const NotFound = () => (
    <PlayContainerBase>
        <Container>
            <Heading>Det finns inget på den här sidan</Heading>
            <Content>
                <ListHeading>Det kan bero på:</ListHeading>
                <List>
                    <li>Att du följt en länk som inte fungerar</li>
                    <li>Att programmet du försökt nå inte längre visas på SVT Play</li>
                </List>
                <ListHeading>Du kan:</ListHeading>
                <List>
                    <li>Ändra webbadressen</li>
                    <li>Göra en ny sökning överst på sidan</li>
                    <li>
                        Gå till{' '}
                        <PlayLink href="/" underline>
                            Start
                        </PlayLink>{' '}
                        eller{' '}
                        <PlayLink href="/program" underline>
                            Program
                        </PlayLink>
                    </li>
                </List>
                <PlayText size={SIZE.LARGE}>
                    Om du inte hittar det du söker,{' '}
                    <ExternalLink href="https://kontakt.svt.se">kontakta oss</ExternalLink>.
                </PlayText>
            </Content>
        </Container>
        <NotFoundRecommendations />
    </PlayContainerBase>
);

export default NotFound;
